import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { api } from "@/lib/backend";
import { extractionWrapper } from "@/lib/backend/utils/extract";
import { PROJECT_QUERY_KEY } from "@/lib/requests/project/project.key";

const KEY = PROJECT_QUERY_KEY;
const API = api.project;

export const queryOptions_projects_employee_day_range = (
  params: Parameters<typeof API.getEmployeeDayRange>[0],
) =>
  queryOptions({
    queryKey: [KEY, "employee-day-range", params] as const,
    queryFn: () =>
      extractionWrapper(
        API.getEmployeeDayRange({
          ...params,
        }),
      ),
    placeholderData: keepPreviousData,
  });
